import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import TeacherCombo from '../combos/TeacherCombo';
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Col, Form, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';
import ShowVideo from '../shared/ShowVideo';



export default function SendSmsByGroup(props) {
    const toast = useRef(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [classes, setClasses] = useState([]);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [create, setCreate] = useState(true);

    const [chkClassAll, setChkClassAll] = useState(false);
    const [chkClassSelection, setChkClassSelection] = useState(true);
    const [toStudent, setToStudent] = useState(false);
    const [toParent, setToParent] = useState(false);
    const [message, setMessage] = useState("");

    

    useEffect(() => {
      setSaving(true);
      var params = {login:util.getTrustedUser()};
      var url = config.Server+`/school/school-data/all/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var classesTmp = response.classes;
                  for(var i=0;i<classesTmp.length;i++){
                    classesTmp[i]["isChecked"] = false;
                  }
                  setClasses(classesTmp);
                  
                  setSaving(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
    }, []);
    const checkDataEntry = function(){
      if(message == null || message == ""){
        setErorVisible(true);
        setErrorMessage("متن پیام را مشخص نمائید");
        return false;
      }
      if((!toStudent) && (!toParent)){
        setErorVisible(true);
        setErrorMessage("نوع مخاطب(دانش آموز یا ولی دانش آموز) را مشخص نمائید")
        return false;
      }
      return true;
    }

    const saveItem = function(){
      if(!checkDataEntry()) return;
      var classesTmp = [];

      for(var i=0;i<classes.length;i++)
        if(classes[i].isChecked)
          classesTmp.push(classes[i].code);

      
      if(classesTmp.length == 0){
        setErorVisible(true);
        setErrorMessage("هیچ کلاسی انتخاب نشده است");
        return false;
      }
      var params = {
        login:util.getTrustedUser(), 
        message:message,
        toStudent:toStudent,
        toParent:toParent,
        classes:classesTmp,
      };
      var url = config.Server+`/school/sms/by-class/send`;
      if(create) url = config.Server+`/school/mobile-sms/by-class/create`;
      console.log("params to replace is>", params)
      
      setSaving(true);
        axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                toast.current.show({ severity: 'info', summary: 'Info', detail: 'با موفقیت ارسال شد' });              
                setSaving(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    const onClassCheckboxesChange = (e, isAll, index) => {
        var tmp = [...classes];
        if(index == -1){
          if(isAll) {
            setChkClassAll(true);
            setChkClassSelection(false);
            for(var i=0;i<tmp.length;i++)tmp[i].isChecked = true;
          }
          else{
            setChkClassAll(false);
            setChkClassSelection(true);
          }
        }
        else{
          tmp[index].isChecked = e.checked;
        }
        setClasses(tmp);
    }
    return(      
      (redirectUrl != "")
          ?
          <Navigate to={redirectUrl} replace={false}  />
      :
      <>
      <ShowVideo videoId="school_send_sms" top={65} md={6} /> 
         <Row style={{paddingTop:"0px", margin:"5px", border:"1px solid #b0b0b0", borderRadius:"5px"}}>
            <Col md={12} style={{backgroundColor:"royalblue", color:"#FFFFFF",padding:"5px", borderRadius:"5px", fontSize:"14pt"}}>
                ارسال گروهی پیامک
            </Col>
            <Row style={{margin:"10px 0px 0px 0px", padding:"0px 0px 0px 0px"}}>
              <Col md={12}>
                متن پیام:
                <br></br>
                <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setMessage(e.target.value)}} value={message} />
              </Col>
            </Row>
            <Row style={{marginTop:"15px"}}>
              <Col md={12}>
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chk1" onChange={(e)=>{onClassCheckboxesChange(e, true, -1)}} checked={chkClassAll} />
                      <label htmlFor="chk1" className="ml-2"> &nbsp;ارسال به همه کلاس ها</label>
                  </div>                
              </Col>
              <Col md={12}>
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chk2" onChange={(e)=>{onClassCheckboxesChange(e, false, -1)}} checked={chkClassSelection} />
                      <label htmlFor="chk2" className="ml-2"> &nbsp;ارسال فقط به کلاس های زیر</label>
                  </div>
              </Col>
              <Col md={12} style={{border:"1px solid #b0b0b0", margin:"5px 25px 5px 50px", width:"calc(100% - 10px", padding:"3px", maxHeight:"450px", overflowY:"scroll"}}>
                {
                  classes.map((cls, index)=>{
                    return(
                      <div className="flex align-items-center" style={{marginTop:"5px", width:"150px", float:"right", height:"30px", overflow:"hidden"}}>
                          <Checkbox disabled={chkClassAll} inputId={"chk3_" + String(index)} onChange={(e)=>{onClassCheckboxesChange(e, false, index)}}  checked={classes[index].isChecked} />
                          <label htmlFor={"chk3_" + String(index)} className="ml-2"> &nbsp;{cls.name}</label>
                      </div>
                    )
                  })
                }
              </Col>
            </Row>
            <Row style={{marginTop:"15px"}}>
              <Col md={12} style={{border:"1px solid #b0b0b0", margin:"5px 25px 5px 50px", width:"calc(100% - 10px", padding:"3px 3px 10px 3px", maxHeight:"450px", overflowY:"scroll"}}>
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chkToStudent" onChange={(e)=>{setToStudent(e.checked)}} checked={toStudent} />
                      <label htmlFor="chkToStudent" className="ml-2"> &nbsp;ارسال به موبایل دانش آموز</label>
                  </div>                
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chkToPaarent" onChange={(e)=>{setToParent(e.checked)}} checked={toParent} />
                      <label htmlFor="chkToPaarent" className="ml-2"> &nbsp;ارسال به موبایل ولی دانش آموز</label>
                  </div> 
                  <div style={{backgroundColor:"#d8f3d7ff", padding:"3px 0px", marginTop:"5px"}}>
                      <div className="flex align-items-center" style={{marginTop:"10px", marginBottom:"10px"}}>
                          <Checkbox inputId={"chk_2"} onChange={(e)=>{setCreate(e.checked)}} checked={create} />
                          <label htmlFor={"chk_2"} className="ml-2"> &nbsp;پیامک با پنل ارسال نشود. می خواهم با موبایل خودم ارسال کنم</label>
                      </div>                
                      <div>
                        اگر گزینه فوق را تیک بزنید پیامک توسط پنل اینترنی ارسال نمی شود. 
                             در این حالت پیامک دخیره شده و می توانید با کمک اپلیکیشن کلاسیکو7 آنرا ارسال نمائید و موجب کاهش هزینه ارسال پیامک به نرخ همراه اول یا ایرانسل گردد. 
                      </div>
                  </div>               
              </Col>
            </Row>
            
            
            <Row style={{margin :"20px 0px"}}>
              <Col md={3}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                    <Button label={(create?"ایجاد":"ارسال") +" پیامک(ها)"} icon="pi pi-check" onClick={()=>saveItem(true)} severity="success" iconPos="right" loading={saving} />                    
                  </div>
              </Col>
            </Row>
         </Row>
          <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
          <Toast ref={toast} />            
      </>  
    );
  
}
